import { useQuery } from '@tanstack/react-query';

import { getGHADiscountSummary } from '~/services/ConnectionGoogleService';

export const ghaDiscountSummaryQueryKeys = {
  all: ['ghaDiscountSummary'] as const,
};

export function useGHADiscountSummary() {
  return useQuery({
    queryKey: ghaDiscountSummaryQueryKeys.all,
    queryFn: async ({ signal }) => {
      const response = await getGHADiscountSummary({ signal });
      return response.result;
    },
  });
}
